<template>
    <v-app :style="{fontFamily: fontFamily, color: contentColor}">
        <v-navigation-drawer
            v-model="drawer"
            app
            :permanent="($vuetify.breakpoint.xlAndUp) ? true : false"
            v-if="pages.length>0"
        >
            <v-list-item :style="{backgroundColor: navColor}">
                <v-list-item-content>
                    <v-list-item-title class="text-h6" :style="{color: textnavColor}">
                        {{ storeName }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            

            <v-divider></v-divider>
            <!-- main list -->
            <v-list
                nav
            >
                <v-list-item :href="`/${slug}`">
                    <v-list-item-title>{{$t('Tienda')}}</v-list-item-title>
                </v-list-item>
                <template v-for="(page, k) in pages">
                    <v-list-item :href="`/${slug}/my/${page.slug}`" :key="k">
                        <v-list-item-title>{{ page.title }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
            <!-- end main list -->
        </v-navigation-drawer>

        <!-- app bar -->
        <v-app-bar
            app
            dark
            :color="bannerColor"
            :src="(ifBanner)?banner:''"
            :height="height"
            elevate-on-scroll
        >
            <template v-slot:img="{ props }">
                <v-img
                    v-bind="props"
                    :gradient="`to top right, ${bannerColor}96, ${bannerColor}59`"
                ></v-img>
            </template>

            <!-- mobile -->
            <v-btn
                icon
                :x-large="!$vuetify.breakpoint.smAndDown"
                :color="textbannerColor"
                @click="tableMapDialog=!tableMapDialog"
                v-if="tableMap!='' && $vuetify.breakpoint.smAndDown"
            >
                <v-icon>mdi-table-chair</v-icon>
            </v-btn>
            <v-btn
                icon
                :x-large="!$vuetify.breakpoint.smAndDown"
                :color="textbannerColor"
                class="ml-0"
                @click="dialogSearch=!dialogSearch"
                v-if="$vuetify.breakpoint.smAndDown"
            >
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <!-- mobile END -->
            <div v-if="tableMap!=''">
                <div v-if="!$vuetify.breakpoint.smAndDown" style="width:208px;"></div>
            </div>
            <div v-else>
                <div v-if="!$vuetify.breakpoint.smAndDown" style="width:156px;"></div>
                <div v-if="$vuetify.breakpoint.smAndDown" style="width:52px;"></div>
            </div>

            <v-spacer></v-spacer>

            <v-toolbar-title>
                <img :src="logo" alt="Logo">
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn
                icon
                :x-large="!$vuetify.breakpoint.smAndDown"
                :color="textbannerColor"
                @click="dialogSearch=!dialogSearch"
                v-if="!$vuetify.breakpoint.smAndDown"
            >
                <v-icon>mdi-magnify</v-icon>
            </v-btn>

            <v-btn
                icon
                :x-large="!$vuetify.breakpoint.smAndDown"
                :color="textbannerColor"
                @click="tableMapDialog=!tableMapDialog"
                v-if="tableMap!='' && !$vuetify.breakpoint.smAndDown"
            >
                <v-icon>mdi-table-chair</v-icon>
            </v-btn>

            <v-menu bottom offset-y v-if="name!=''">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        :color="textbannerColor"
                        :x-large="!$vuetify.breakpoint.smAndDown"
                    >
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>

                <v-list style="min-width: 250px">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('Hola!')}}</v-list-item-title>
                            <v-list-item-subtitle>
                                {{ name }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <v-icon>mdi-logout-variant</v-icon> &nbsp;
                        {{$t('Salir')}}
                    </v-list-item>
                </v-list>
            </v-menu>
            <!-- <v-btn
                v-else
                icon
                :color="textbannerColor"
                :x-large="!$vuetify.breakpoint.smAndDown"
                @click="dialogLogin=!dialogLogin"
            >
                <v-icon>mdi-account-circle</v-icon>
            </v-btn> -->

            <v-badge
                :content="cantProds"
                :value="cantProds"
                :color="btnColor"
                overlap
            >
                <v-btn
                    icon
                    :x-large="!$vuetify.breakpoint.smAndDown"
                    :color="textbannerColor"
                    @click="openPurchase"
                    :disabled="emergency"
                >
                    <v-icon>mdi-cart</v-icon>
                </v-btn>
            </v-badge>

            <template v-slot:extension>
                <v-tabs
                    slider-size="5"
                    :background-color="navColor"
                    :color="btnColor"
                    centered
                    show-arrows
                >
                    <template v-for="(cat, k) in dataMyStore">
                        <v-tab :key="k" @click="scrollTo(`#${cat.slug}`)" v-if="cat.products.length > 0">
                            <div :style="`color:${textnavColor}`">{{ cat.name }}</div>
                        </v-tab>
                    </template>
                </v-tabs>
            </template>
        </v-app-bar>
        <!-- end app bar -->

        <!-- app main -->
        <v-main class="bg" :style="(ifBody)?`background-image: url(${body})`:`background-color: ${bodyColor}`">
            <waiter-products
                :slug="slug"
                
                :title-color="titleColor"
                :title-card-color="titleCardColor"
                :price-color="priceColor"
                :btn-color="btnColor"
                :textbtn-color="textbtnColor"
                :banner-color="bannerColor"
                :textnav-color="textnavColor"
                :nav-color="navColor"
                :font-family="tmpFontFamily"
                :data-my-store="dataMyStore"
                :consult-wps="consultWps"
                :store-phone="storePhone"
                :code-phone="codePhone"
                :store-name="storeName"
                :emergency="emergency"
                :money="money"
                :content-color="contentColor"
                :temp-mode="tempMode"
                @update-cart="updateCartFromStore"
                @open-cart="openCartFromStore"
                v-if="typePage=='store'"
            ></waiter-products>
            <div v-else>
                <slot/>
            </div>
            <!-- <slot/> -->
        </v-main>
        <!-- end app main -->

        <!-- app footer -->
        <v-footer
            padless
        >
            <v-card
                flat
                tile
                width="100%"
                class="text-center"
                :color="bannerColor"
            >
                <v-card-text>
                    <v-btn
                        text
                        :color="textbannerColor"
                        class="text-capitalize"
                        target="_blank"
                        href="https://wa.me/59169007104?text=Estoy%20interesado%20en%20QUICK%0AQuiero%20empezar%20a%20vender%20en%20l%C3%ADnea%20hoy"
                    >
                        <strong>QUICK</strong> © {{ new Date().getFullYear() }}
                    </v-btn>
                </v-card-text>
                
            </v-card>
        </v-footer>
        <!-- end app footer -->

        <!-- bottom -->
        <v-card
            v-if="cantProds>0 || showListCoupons"
            class="ed-sheet"
            tile
        >
            <v-container>
                <v-row>
                    <v-col cols="12" sm="8" offset-sm="2" v-if="showListCoupons" :class="(cantProds>0)?'pb-1':''">
                        <v-row no-gutters align="center">
                            <v-col cols="6" sm="5" class="text-center text-sm-right">
                                <div :style="`color:${titleColor}`">
                                    <Countdown class="pl-0" v-if="showTime" :end="currentTime"></Countdown>
                                </div>
                            </v-col>
                            <v-col cols="6" sm="7">
                                <div
                                    v-for="item in listCoupons"
                                    :key="item.name"
                                    class="d-flex justify-center align-center"
                                >
                                    <!-- <span class="pr-2">{{ item.name }}</span> -->
                                    <v-btn
                                        small
                                        class="pl-2"
                                        :color="btnColor"
                                        :style="`color:${textbtnColor}`"
                                        @click="copyData(item.name)"
                                    >{{$t('Copiar cupón')}}</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" v-if="cantProds>0" class="pb-7" :class="(showListCoupons)?'pt-1':''">
                        <v-btn
                            block
                            large
                            rounded
                            :color="btnColor"
                            :style="`color:${textbtnColor}`"
                            @click="openPurchase"
                        >
                            <strong>{{$t('Ir al pago')}}</strong>
                            <v-icon right>mdi-cart</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <!-- end bottom -->

        <!-- dialog cart -->
        <!-- <div class="d-flex justify-end">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="openDetails(item, i)"
                    >
                        <v-icon color="grey">
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                </template>
                <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="removeItemOfCart(item.prodId, i)"
                    >
                        <v-icon color="grey">
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </template>
                <span>Eliminar</span>
            </v-tooltip>
        </div> -->
        <!-- dialog cart end -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-overlay
                    absolute
                    :value="overlayProd"
                    opacity=".8"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="success"
                    ></v-progress-circular>
                </v-overlay>
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>

                <v-card-text class="pb-5 px-0">
                    <v-card-title :style="`color:${navColor}`" class="pa-0">
                        <v-carousel
                            height="auto"
                            class="simple-carousel"
                            :show-arrows="(galleryProd.length<=0)?false:true"
                            hide-delimiters
                            v-if="bannerProd != 'none'"
                        >
                            <v-carousel-item
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="bannerProd"
                                    :lazy-src="bannerProd"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                            <v-carousel-item
                                v-for="(img, j) in galleryProd" :key="j"
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="img.img"
                                    :lazy-src="img.img"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <div class="px-4 py-2" style="width:100%" :style="{'color':contentColor}">
                            {{ nameProd }}
                        </div>
                    </v-card-title>

                    <div class="px-5 mb-5" v-if="descriptionProd">
                        {{ descriptionProd }}
                    </div>

                    <template v-for="(row, j) in optionsProd">
                        <v-card-title :key="j" class="py-3" :style="{backgroundColor: navColor, color: textnavColor}">
                            {{ row.title }}
                        </v-card-title>
                        <v-alert
                            :key="j+1*150"
                            dense
                            tile
                            outlined
                            type="error"
                            v-if="showAlertRequired && row.isRequired"
                        >Debe seleccionar una opción para continuar</v-alert>
                        <!-- multiple -->
                        <v-list :key="j+10" v-if="row.type == 'multiple'">
                            <template dense>
                                <v-list-item v-for="(opt) in row.values" :key="opt.name">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} +{{ opt.price }}</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                        <v-btn
                                            small
                                            :disabled="opt.quantity<=0"
                                            @click="changeQtyMultiple(row, opt, -1)"
                                        >
                                            <v-icon dark>
                                                mdi-minus
                                            </v-icon>
                                        </v-btn>
                                        <v-sheet
                                            height="28"
                                            width="60"
                                            class="sheet-cant"
                                        >
                                            {{ opt.quantity }}
                                        </v-sheet>
                                        <v-btn
                                            small
                                            :disabled="(opt.quantity<=0 && (row.tmpVal).length >= row.select) || (row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) >= row.selectQuantity)"
                                            @click="changeQtyMultiple(row, opt, 1)"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                    </div>

                                    <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${opt.price}:${opt.quantity}`"></span>

                                    <!-- con cantidad, la selección se hace con +/- (cantidad > 0 = seleccionado) -->
                                    <v-list-item-action v-if="!row.ifQuantity">
                                        <v-checkbox
                                            v-model="row.tmpVal"
                                            :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                            :color="btnColor"
                                            :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                            @change="changeRespMultiple"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                            <!-- <v-list-item-group
                                v-model="row.tmpVal"
                                multiple
                                active-class=""
                                @change="changeRespMultiple"
                            >
                                <v-list-item :disabled=" ((row.tmpVal).includes(opt.name+':'+opt.price)) ? false : ((row.tmpVal).length >= row.select) " v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+opt.price">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">+{{ opt.price }} {{ money }}</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon :color="btnColor" v-if="active">
                                                mdi-checkbox-marked
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group> -->
                        </v-list>
                        <!-- multiple end -->
                        <!-- only -->
                        <v-list :key="j+20" v-if="row.type == 'only'">
                            <v-list-item-group
                                v-model="row.tmpValOnly"
                                active-class=""
                                @change="changeRespOnly"
                            >
                                <v-list-item v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+opt.price">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} +{{ opt.price }}</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon :color="btnColor" v-if="active">
                                                mdi-circle-slice-8
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <!-- only end -->
                    </template>

                    <v-divider></v-divider>

                    <div class="px-5 pt-5">
                        <v-textarea
                            outlined
                            placeholder="Dato extra"
                            :color="btnColor"
                            rows="3"
                            v-model="dataExtra"
                        ></v-textarea>
                    </div>

                </v-card-text>

                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="6">
                            <div class="d-flex align-center">
                                <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                    <v-icon dark>
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <v-text-field
                                    placeholder="Cantidad"
                                    :color="btnColor"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="stock"
                                    hide-details
                                    v-model="quantity"
                                    style="width:100px;max-width:100px;"
                                    @input="changeQuantity($event)"
                                ></v-text-field>
                                <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="updateToCart"
                            >
                                <strong>Actualizar {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- dialog purchase -->
        <v-dialog
            v-model="dialogPurchase"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <waiter-purchase
                :slug="slug"
                :mesa="mesa"
                :title-color="titleColor"
                :btn-color="btnColor"
                :textbtn-color="textbtnColor"
                :banner-color="bannerColor"
                :textnav-color="textnavColor"
                :nav-color="navColor"
                :data-my-store="dataMyStore"
                :up-cart="cart"
                :font-family="tmpFontFamily"
                :last-purchase="lastPurchase"
                :closed-store="closedStore"
                :money="money"
                :content-color="contentColor"
                :temp-mode="tempMode"
                :iso2="iso2"
                :valCoupon="valCoupon"
                :nameCoupon="nameCoupon"
                :discountProds="discountProds"
                @send-success="successOrder"
                @close-purchase="dialogPurchase=!dialogPurchase"
            ></waiter-purchase>
                <!-- @update-cart="updateCartFromStore" -->
        </v-dialog>
        <!-- dialog purchase END -->

        <v-dialog
            v-model="dialogSearch"
            fullscreen
            transition="dialog-bottom-transition"
            content-class="dialog-fullwidth white"
        >
            <v-container>
                <v-card tile elevation="0">
                    <v-card-text class="pa-0">
                        <v-text-field
                            placeholder="¿Qué te gustaría pedir?"
                            outlined
                            dense
                            hide-details
                            autofocus
                            :color="btnColor"
                            prepend-inner-icon="mdi-magnify"
                            v-model="txt"
                            :loading="loadSearch"
                            @input="searchProducts"
                        >
                            <template v-slot:append>
                                <v-btn v-show="txt!=''"
                                    icon
                                    small
                                    color="red"
                                    class="mt-n1"
                                    @click="clearSearch"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-dialog>

        <!-- dialog -->
        <v-dialog
            v-model="dialogLogin"
            max-width="400"
            content-class="grey lighten-4"
        >
            <v-card>
                <v-card-title>
                    <strong>{{$t('Inicia sesión')}}</strong>
                </v-card-title>
            </v-card>
            <v-card-text>
                <p class="grey--text"><small>{{$t('Si ya tienes una cuenta puedes iniciar sesión desde aquí.')}}</small></p>
                <v-form @submit.prevent="loginUser" ref="refLogin" lazy-validation>
                    <v-text-field
                        :label="$t('Número de celular')"
                        outlined
                        dense
                        :color="btnColor"
                        type="text"
                        v-model="dataAuth.username"
                        :rules="[rules.required]"
                        :error="errors['username'] ? true :false"
                        :error-messages="errors['username'] ? errors['username'][0] : ''"
                    >
                        <!-- <template v-slot:prepend-inner>
                            <div class="ed-prepend">
                                +591
                            </div>
                        </template> -->
                    </v-text-field>
                    <v-text-field
                        :label="$t('Contraseña')"
                        outlined
                        dense
                        :color="btnColor"
                        type="password"
                        v-model="dataAuth.password"
                        :rules="[rules.required]"
                        :error="errors.password ?true :false"
                        :error-messages="errors['password'] ? errors['password'][0] : ''"
                    ></v-text-field>
                    <!-- <div class="text-left mb-4">
                        <a href="javascript:;" @click="dialogLogin=false, dialogReset=true">Recuperar contraseña</a>
                    </div> -->
                    <v-btn
                        :color="btnColor"
                        :style="`color:${textbtnColor}`"
                        block
                        type="submit"
                        :loading="loading"
                    ><strong>{{$t('Ingresar')}}</strong></v-btn>
                </v-form>
            </v-card-text>
        </v-dialog>
        <!-- end dialog -->

        <!-- ventas -->
        <v-dialog
            v-model="dialogSales"
            width="1200"
            overlay-opacity=".9"
        >
            <my-sales :money="money" type-resp="sales"></my-sales>
        </v-dialog>
        <!-- ventas END -->

        <!-- map -->
        <v-dialog
            v-model="tableMapDialog"
            width="1200"
            scrollable
        >
            <v-card>
                <v-card-title>
                    <strong>{{$t('Ubicación de la tienda')}}</strong>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="tableMapDialog=false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-img :src="tableMap"></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- map END -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="success"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </v-app>
</template>
<script>
import Countdown from 'vuejs-countdown'
export default {
    components: { Countdown },
    data() {
        return {
            tmpName: '',
            overlay: true,
            drawer: false,
            // menu
            dataMyStore: [],
            storePhone: '',
            storeName: '',
            // settings
            bannerColor: '',
            textbannerColor: '',
            navColor: '',
            textnavColor: '',
            ifBanner: true,
            logo: '',
            banner: '',
            btnColor: '',
            textbtnColor: '',
            contentColor: '',
            titleColor: '',
            titleCardColor: '',
            priceColor: '',
            fontFamily: '',
            tmpFontFamily: '',
            consultWps: false,
            ifBody: false,
            bodyColor: '',
            body: '',
            emergency: false,
            money: '',
            tableMap: '',
            tableMapDialog: false,
            // cart
            cart: {},
            tmpIndex: null,
            wspCart: '',
            cantProds: 0,
            total: 0,
            // open product
            overlayProd: false,
            loadProd: true,
            dialogProd: false,
            prodId: '',
            bannerProd: '',
            galleryProd: [],
            nameProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            stock: 100,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: '',
            respOnlyVal: 0,
            showRequired: false,
            showAlertRequired: false,
            // purchase
            dialogPurchase: false,
            iso2: '',
            codePhone: '',
            // search
            dialogSearch: false,
            loadSearch: false,
            txt: '',
            // last
            lastPurchase: {},
            // schedukes
            listSchedules: {},
            closedStore: false,
            // login
            loading: false,
            dialogLogin: false,
            dataAuth: {
                username: '',
                password: ''
            },
            // mode
            tempMode: 'order_auto',
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos'
            },
            errors: {},
            // pages
            pages: [],
            // time
            currentTime: null,
            showTime: false,
            listCoupons: [],
            couponTxt: '',
            nameCoupon: '',
            valCoupon: 0,
            showListCoupons: false,
            discountProds: 0,
            // ventas
            dialogSales: false
        }
    },
    props: ['slug' , 'mesa', 'msgNotify', 'name', 'userId', 'typePage'],
    watch: {
        // respMultiple(resp) {
        //     this.respMultipleVal = 0
        //     if (resp.length > 0) {
        //         resp.forEach(el => {
        //             let tmpPrice = +(el.split(':')[1])
        //             this.respMultipleVal += tmpPrice
        //         });
        //     }
        // },
        // respOnly(resp) {
        //     this.respOnlyVal = 0
        //     if (resp) {
        //         let tmpPrice = +(resp.split(':')[1])
        //         this.respOnlyVal = tmpPrice
        //     }
        // },
        dialogProd(e) {
            if (!e) {
                this.respMultiple = []
                this.respMultipleVal = 0

                this.respOnly = ''
                this.respOnlyVal = 0

                this.dataExtra = ''

                this.optionsProd = []
            }
        }
    },
    mounted() {
        this.getSettingStore()
        this.getDataStore()   

        if (localStorage.getItem(this.slug)) {
            this.cart = JSON.parse(localStorage.getItem(this.slug))

            for (var [key, value] of Object.entries(this.cart)) {
                var tmpComplements = this.cart[key].complements
                this.cart[key].complementsDetails = ''
                if (tmpComplements.multi.length > 0) {
                    tmpComplements.multi.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
                if (tmpComplements.only.length > 0) {
                    tmpComplements.only.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
            }

            this.cantProds = Object.keys(this.cart).length;
            this.calculateTotal()
            this.generateMsgWsp()
        }

        // login
        if (localStorage.getItem('login')) {
            setTimeout(() => {
                this.$fire({
                    title: 'Inicio de sesión con éxito.',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Continuar',
                    confirmButtonColor: this.btnColor,
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.tmpFontFamily
                    }
                })
                localStorage.removeItem('login')
            }, 300);
        }

        // timer
        if (sessionStorage.getItem(`${this.slug}-coupon`)) {
            this.showListCoupons = sessionStorage.getItem(`${this.slug}-coupon`)
        }
    },
    created() {
        if (this.msgNotify) {
            switch (this.msgNotify) {
                case 'success':
                    this.dialogOkProd = true
                    break;
                case 'error':
                    this.dialogErrorProd = true
                    break;
                default:
                    this.$notify.info(this.msgNotify)
                    break;
            }
        }
    },
    methods: {
        // Copy Text to Clipboard
        async copyData(txt) {
            var temp = document.querySelector('.temp-copy');
            temp.value = txt;
            temp.select();
            document.execCommand('copy');
            this.$notify.success('Cupón copiado.')
        },
        /**
         * login
         */
        async loginUser() {
            if (this.$refs.refLogin.validate()) {
            // if (true) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('login', this.dataAuth.username)
                formData.append('password', this.dataAuth.password)
                formData.append('store', this.slug)
                await axios.post('/login', formData)
                .then(response => {
                    // console.log(response)
                    if (response.status === 204) {
                        window.location.reload()
                        localStorage.setItem('login', 'ok')
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        },
        /**
         * logout
         */
        async logout () {
            await axios.post(`/logout`)
            .then((response) => {
                if (response.status === 204) {
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        //
        scrollTo(to) {
            this.$vuetify.goTo(to, {duration: 1000, offset: 20, easing: 'easeInOutCubic'})
        },
        /**
         * active tab
         */
        updateTabs() {
            switch (window.location.pathname) {
                case '/':
                    this.tab = 0;
                    break;
                case '/categorias':
                    this.tab = 1;
                    break;
                case '/productos':
                    this.tab = 2;
                    break;
                default:
                    this.tab = null;
                    break;
            }
        },
        goTo(to) {
            window.location.href = to
        },
        /**
         * logout
         */
        async logout () {
            await axios.post(`/logout`)
            .then((response) => {
                if (response.status === 204) {
                    localStorage.removeItem('name')
                    // redirect to slug path
                    location.href = `/${this.slug}/login-waiter`
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },

        /**
         * main store
         */
        async getSettingStore() {
            const formData = new FormData
            // formData.append('slug', this.slug)
            // formData.append('_method', 'POST')
            await axios.get(`/store-data/${this.slug}`)
            .then(response => {
                // console.log(response)
                if (response.data[0]) {
                    this.bannerColor = response.data[0].banner_color
                    this.textbannerColor = response.data[0].textbanner_color
                    this.navColor = response.data[0].nav_color
                    this.textnavColor = response.data[0].textnav_color
                    this.ifBanner = response.data[0].if_banner
                    this.logo = response.data[0].logo
                    this.banner = response.data[0].banner
                    this.btnColor = response.data[0].btn_color
                    this.textbtnColor = response.data[0].textbtn_color
                    this.contentColor = response.data[0].content_color
                    this.titleColor = response.data[0].title_color
                    this.titleCardColor = response.data[0].titlecard_color
                    this.priceColor = response.data[0].price_color
                    this.fontFamily = response.data[0].font_family
                    this.consultWps = (response.data[0].consult_wps)?true:false
                    this.ifBody = response.data[0].if_body
                    this.bodyColor = response.data[0].body_color
                    this.body = response.data[0].body
                    this.emergency = (response.data[0].emergency)?true:false
                    const font = (response.data[0].font_family).replace(/[^a-zA-Z ]/g, "")
                    this.tmpFontFamily = font.replace(/\s+/g, '-').toLowerCase()
                    this.money = response.data[0].money
                    this.tableMap = response.data[0].table_map
                }
                if (response.data[2]) {
                    this.storePhone = response.data[2]
                }
                if (response.data[3]) {
                    this.storeName = response.data[3]
                }
                if (response.data[4]) {
                    this.pages = response.data[4]
                }
                if (response.data[5]) {
                    this.tempMode = response.data[5]
                }
                if (response.data[6]) {
                    this.iso2 = response.data[6]
                }
                if (response.data[7]) {
                    this.codePhone = response.data[7]
                }
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },

        /**
         * main data
         */
        clearSearch() {
            this.txt = ''
            this.getDataStore()
            this.dialogSearch = false
        },
        searchProducts(event) {
            if (event!='') this.loadSearch = true
            setTimeout(() => {
                this.getDataStore(event)
            }, 500);
        },
        async getDataStore(txt='') {
            await axios.post('/my-store', {slug: this.slug, search: txt})
            .then((response) => {
                // console.log(response.data);
                this.dataMyStore = response.data[0].data
                response.data[0].data.forEach(element => {
                    element.products.forEach(prod => {
                        prod.promo = false
                        const tempDates = JSON.parse(prod.promo_dates)
                        const tempInit = prod.promo_init
                        const tempEnd = prod.promo_end
                        if (tempDates && tempDates.length>0) {
                            // dates
                            const d = new Date()
                            const init = new Date()
                            const end = new Date()
                            const currentDate = d.getFullYear() +'-'+ ( (d.getMonth()<9)?'0'+(d.getMonth()+1):(d.getMonth()+1) ) +'-'+ ( (d.getDate()<10)?'0'+d.getDate():d.getDate() )
                            if (tempDates.includes(currentDate)) {
                                if (tempInit && tempEnd) {
                                    const on = tempInit.split(':')
                                    init.setHours(+on[0])
                                    init.setMinutes(+on[1])
                                    // init.setSeconds(+on[2])
                                    const off = tempEnd.split(':')
                                    end.setHours(+off[0])
                                    end.setMinutes(+off[1])
                                    // end.setSeconds(+off[2])

                                    if (d.getTime() > init.getTime() && d.getTime() < end.getTime()) {
                                        prod.promo = true
                                    }
                                }
                            }
                        }
                    });
                });
                this.loadSearch = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loadSearch = false
            })
        },

        /**
         * update cart
         */
        updateCartFromStore(cart) {
            this.cart = JSON.parse(cart)

            for (var [key, value] of Object.entries(this.cart)) {
                var tmpComplements = this.cart[key].complements
                this.cart[key].complementsDetails = ''
                if (tmpComplements.multi.length > 0) {
                    tmpComplements.multi.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
                if (tmpComplements.only.length > 0) {
                    tmpComplements.only.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
            }

            this.cantProds = Object.keys(this.cart).length;
            this.calculateTotal()
            this.generateMsgWsp()
        },
        /**
         * calculate total
         */
        calculateTotal() {
            this.total = 0;
            this.discountProds = 0;
            Object.keys(this.cart).forEach(key => {
                this.total += ((this.cart[key].priceNormal>0)?this.cart[key].priceNormal:this.cart[key].price);
                this.discountProds += ((this.cart[key].priceNormal>0) ? (this.cart[key].priceNormal-this.cart[key].price) :0);
            });
        },
        /**
         * open cart
         */
        openCartFromStore(open) {
            if (open) {
                this.openPurchase()
            }
        },
        /**
         * remove item
         */
        removeItemOfCart(prod, i) {
            this.$confirm(
                '¿Está seguro de eliminar este elemento?',
                'Confirmar',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Sí',
                confirmButtonColor: this.btnColor,
                cancelButtonText: 'No',
                customClass: {
                    container: this.tmpFontFamily
                }
            }).then(res => {
                if (res) {
                    if (localStorage.getItem(this.slug)) {
                        const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                        const newCart = {}
                        for (var [key, value] of Object.entries(tmpCart)) {
                            // if (prod.toString() !== key) {
                            if (i.toString() !== key) {
                                newCart[key] = value
                            }
                        }
                        localStorage.setItem(this.slug, JSON.stringify(newCart))

                        this.updateCartFromStore(JSON.stringify(newCart))
                        this.$notify.success('Se retiro el producto del carrito.');
                    }
                }
            });
        },
        /**
         * open
         */
         changeQtyMultiple(row, opt, step) {
             const key = `${opt.name.replace(' ', '-')}_${opt.price}`
             const newQty = Math.max(0, opt.quantity + step)
             // respetar la cantidad máxima de todos los complementos juntos
             if (step > 0 && row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) + step > row.selectQuantity) return
             const isSelected = row.tmpVal.includes(key)

             if (newQty > 0 && !isSelected) {
                 // respetar el máximo de opciones permitidas
                 if (row.tmpVal.length >= row.select) return
                 row.tmpVal.push(key)
             }
             if (newQty == 0 && isSelected) {
                 row.tmpVal.splice(row.tmpVal.indexOf(key), 1)
             }

             opt.quantity = newQty
             this.changeRespMultiple()
         },
         changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 200);
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(prod, index) {
            this.tmpIndex = index
            this.loadProd = true
            this.dialogProd = true
            axios.get(`/show-product/${prod.prodId}?store=${this.slug}`)
            .then((response) => {
                // console.log(response);
                this.optionsProd = []
                this.respMultipleVal = 0

                this.respOnlyVal = 0

                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpValues = JSON.parse(element.values)
                        var tmpValues2 = []
                        var tmpValues3 = []
                        var tmp2Val = []
                        var tmp2ValOnly = undefined
                        if (element.type == 'multiple') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name.replace(' ', '-')+'_'+el.price
                                    if (prod.complements.multi.length>0) {
                                        prod.complements.multi.forEach(multi => {
                                            // console.log(multi);
                                            const selectedVal = multi.split(':')
                                            const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (selectId == txtVal) {
                                                this.respMultipleVal += (+el.price)*(+selectedVal[2])
                                                tmp2Val.push(txtVal)
                                            }
                                            if (tmpValues2[el.name.replace(' ', '-')+'_'+el.price] === undefined) tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = (element.quantity ? 0 : 1)
                                            tmpValues2[selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]] = +selectedVal[2]
                                            // tmpValues2.push({name:selectedVal[0], price:+selectedVal[1], quantity: +selectedVal[2]})
                                        });
                                        // if (prod.complements.multi.includes(txtVal)) {
                                        //     this.respMultipleVal += (+el.price)
                                        //     tmp2Val.push(txtVal)
                                        // }
                                    } else {
                                        if (tmpValues2[el.name.replace(' ', '-')+'_'+el.price] === undefined) tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = (element.quantity ? 0 : 1)
                                    }
                                });
                            }

                            tmpValues.forEach(val => {
                                for (const key in tmpValues2) {
                                    if (key == val.name.replace(' ', '-')+'_'+val.price) {
                                        tmpValues3.push({name:val.name, price:val.price, quantity:tmpValues2[key]})
                                    }
                                }
                            });
                        }
                        if (element.type == 'only') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name+':'+el.price
                                    // console.log(prod);
                                    if (prod.complements.only.length>0) {
                                        prod.complements.only.forEach(only => {
                                            // console.log(only);
                                            const selectedVal = only.split(':')
                                            // const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (only == txtVal) {
                                                this.respOnlyVal += (+selectedVal[1])
                                                tmp2ValOnly = txtVal
                                            }
                                            // tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                            // tmpValues2[selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]] = +selectedVal[2]
                                            // tmpValues2.push({name:selectedVal[0], price:+selectedVal[1], quantity: +selectedVal[2]})
                                        });
                                        // if (prod.complements.multi.includes(txtVal)) {
                                        //     this.respMultipleVal += (+el.price)
                                        //     tmp2Val.push(txtVal)
                                        // }
                                    } else {
                                        // tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                    }
                                });

                            }
                            tmpValues3 = tmpValues
                            // console.log(tmpValues);
                            tmpValues.forEach(val => {
                                tmpValues3.quantity = 1
                            });
                        }
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpValues3,
                            select: element.select,
                            selectQuantity: (+element.select_quantity > 0) ? +element.select_quantity : null,
                            tmpVal: tmp2Val,
                            tmpValOnly: tmp2ValOnly,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price

                // default data
                this.dataExtra = prod.extra
                this.quantity = prod.quantity
                this.respMultiple = prod.complements.multi
                this.respOnly = prod.complements.only

                setTimeout(() => {
                    this.loadProd = false
                }, 500);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        // chabge quantity
        changeQuantity(event) {
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.btnColor,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.tmpFontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                    }
                })
            }
        },
        // change plus and minus
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }
            this.changeQuantity(this.quantity)
        },
        updateToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    name: this.nameProd,
                    // price: this.price,
                    price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                    quantity: this.quantity,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    }
                }

            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                tmpCart[this.tmpIndex] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCart))
            } else {
                let tmpCartInitial = {}
                tmpCartInitial[0] = cart
                // tmpCartInitial[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
            }

            this.updateCartFromStore(localStorage.getItem(this.slug))

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            setTimeout(() => {
                this.$notify.success('Carrito actualizado con éxito.');
            }, 500);
        },

        /**
         * success
         */
        successOrder() {
            this.dialogPurchase = false

            this.cart = {}
            this.cantProds = 0
            this.calculateTotal()
        },

        /**
         * open purchase
         */
        async openPurchase() {
            this.dialogPurchase = !this.dialogPurchase
        },

        /**
         * generate msg wsp
         */
        generateMsgWsp() {
            const cartValues = Object.values(this.cart);
            this.wspCart = `-- Producto --%0a`
            cartValues.forEach(element => {
                // console.log(element);
                this.wspCart += `   ${element.name}   %0a`
            });
            // console.log(this.wspCart);
        },
        showTimeDiv() {
            if (sessionStorage.getItem(`${this.slug}-timer`)) {
                let currentDate = new Date()
                this.currentTime = sessionStorage.getItem(`${this.slug}-timer`)
                let tmpTime = new Date(this.currentTime)

                // atento al tiempo
                let diffMin = tmpTime.getTime() - currentDate.getTime();
                let minutes = new Date(diffMin);
                setTimeout(() => {
                    sessionStorage.setItem(`${this.slug}-coupon`, false)
                    this.showListCoupons = false
                }, 1000 * 60 * ((diffMin <= 0)?0:(+minutes.getMinutes())) );

                // recargar la pagina
                if (diffMin <= 0) {
                    sessionStorage.setItem(`${this.slug}-coupon`, false)
                    this.showListCoupons = false
                }
            } else {
                let currentDate = new Date()
                currentDate.setMinutes(currentDate.getMinutes() + 20)
                sessionStorage.setItem(`${this.slug}-timer`, currentDate.toGMTString())
                this.currentTime = currentDate.toGMTString()
            }
            setTimeout(() => {
                if (this.listCoupons.length > 0) {
                    this.showTime = true
                }
            }, 300);
        },
        onCountdownEnd() {
            console.log('hello');
        },
        useCoupon() {
            sessionStorage.setItem(`${this.slug}-coupon`, true)
            this.showListCoupons = true
        }
    },
    computed: {
        height () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 80
                case 'sm': return 100
                case 'md': return 120
                case 'lg': return 120
                case 'xl': return 120
            }
        },
    },
}
</script>
